import { render, staticRenderFns } from "./busOrder5.vue?vue&type=template&id=1be9d67e&scoped=true&"
import script from "./busOrder5.vue?vue&type=script&lang=js&"
export * from "./busOrder5.vue?vue&type=script&lang=js&"
import style0 from "./busOrder5.vue?vue&type=style&index=0&id=1be9d67e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be9d67e",
  null
  
)

export default component.exports